import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Icon } from "@cdk-uip/react-icon";
import { Menu, MenuAnchor, MenuItem, MenuDivider } from "@cdk-uip/react-menu";

import { ROLES } from "../../constants/constants";

export const AccountMenu = () => {
  let history = useHistory();
  let location = useLocation();

  const [show, setShow] = useState(false);
  const user = JSON.parse(window.sessionStorage.getItem("user"));
  const candidateId = user ? user.id : "";
  const paths = ["/", "/ForgotPassword"];
  const { pathname } = location;

  let onSelected = selected => {
    switch (selected) {
      case 1:
        if (user?.roleId === ROLES.CANDIDATE) {
          if (!["/CandidateForm", "/OnboardingForms"].includes(pathname))
            history.goBack();
          else
            history.push({
              pathname,
              state: {
                candidateId
              }
            });
        } else {
          if (!["/CandidateList", "/RecruitersList"].includes(pathname))
            history.goBack();
        }
        break;
      case 2:
        history.push({
          pathname: "/ChangePassword"
        });
        break;
      case 3:
        history.push("/");
        window.sessionStorage.removeItem("user");
        break;
      default:
        setShow(false);
        break;
    }
    setShow(false);
  };

  return (
    <MenuAnchor>
      {!paths.includes(location.pathname) && !show && (
        <div
          className="on-hover d-flex justify-content-around align-items-center"
          onClick={() => setShow(true)}
        >
          <Icon className="account-icon">account_circle</Icon>
          <span className="navbar-text text-capitalize text-dark">
            {user && user.fullName.split(" ")[0]}
          </span>
        </div>
      )}
      <Menu
        open={show}
        onCancel={() => setShow(false)}
        onSelected={selected => onSelected(selected)}
      >
        <MenuItem className="h-auto" disabled>
          <Icon className="header-account-icon pr-3">account_circle</Icon>
          <span className="menu-text text-capitalize">
            {user && user.fullName}
          </span>
        </MenuItem>
        <MenuDivider />
        {/* Disable Home Button in Menu Options for Onboarding stage Users to avoid editing the details. */}
        <MenuItem className="menu-item">Home</MenuItem>
        <MenuItem className="menu-item">Change Password</MenuItem>

        <MenuItem className="menu-item">Sign Out</MenuItem>
      </Menu>
    </MenuAnchor>
  );
};
